var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 901 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450.641 300V450M450.641 450V600M450.641 450H600.641M450.641 450H300.641",
    className: "svgStroke",
    strokeWidth: 75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M450.641 825C657.747 825 825.641 657.107 825.641 450C825.641 242.893 657.747 75 450.641 75C243.534 75 75.6406 242.893 75.6406 450C75.6406 657.107 243.534 825 450.641 825Z",
    className: "svgStroke",
    strokeWidth: 75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCirclePlus);
export default __webpack_public_path__ + "static/media/akar-icons_circle-plus.aecaaaf4.svg";
export { ForwardRef as ReactComponent };